import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
const files = require.context('.', false, /\.js$/)
const modules = {}
files.keys().forEach((key) => {
  if (key === './index.js') return
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

const i18n = new VueI18n({
  locale: 'zh', // set locale
  messages: modules // set locale messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/assets/lang/index.js